import React, { useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';

const EditOportunidad = ({
  currentOportunidad,
  saveOportunidad,
  closeModal
}) => {
  const [fechaOportunidad, setFechaOportunidad] = useState(new Date());
  const [oportunidad, setOportunidad] = useState(currentOportunidad);

  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Row>
          <Col>
            <Form.Group className="mb-4">
              <Form.Label>Fecha Oportunidad</Form.Label>
              <DatePicker
                popperPlacement="bottom-start"
                selected={fechaOportunidad}
                onChange={date => {
                  if (date instanceof Date && !isNaN(date)) {
                    setFechaOportunidad(date);
                  }
                }}
                className="form-control"
                placeholderText="DD-MM-YYYY HH:mm"
                timeIntervals={5}
                dateFormat="dd-MM-yyyy HH:mm"
                showTimeSelect
                fixedHeight
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className="mb-4">
              <Form.Label>Oportunidad</Form.Label>
              <FormControl
                onChange={e => setOportunidad(e.target.value)}
                type="text"
                defaultValue={oportunidad}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col>
            <Button
              type="button"
              color="primary"
              size="sm"
              onClick={() => {
                saveOportunidad({
                  oportunidad: oportunidad,
                  fechaOportunidad: fechaOportunidad
                });
                closeModal();
              }}
            >
              Guardar
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
EditOportunidad.propTypes = {
  closeModal: PropTypes.func,
  currentOportunidad: PropTypes.string,
  currentFechaOportunidad: PropTypes.date,
  saveOportunidad: PropTypes.func
};
export default EditOportunidad;
